import { deleteRelease, setReleaseTag } from '../../api/releases';
import { setAlert } from '../../helpers/alerts';

export function deleteReleaseWithAlert(
  version,
  {
    reloadData,
    onDeleted,
    successTitle = 'delete',
    errorTitle = 'delete',
  } = {}
) {
  return deleteRelease(version)
    .then((r) => {
      reloadData?.();
      setAlert(successTitle, `Deleted release "${r.version}"`, 'success');
      onDeleted?.(r);
      return r;
    })
    .catch((e) => {
      setAlert(errorTitle, e, 'danger');
      throw e;
    });
}

export function setReleaseTagWithAlert(
  version,
  payload,
  {
    reloadData,
    successTitle,
    successMessage,
    errorTitle,
  }
) {
  return setReleaseTag(version, payload)
    .then((r) => {
      reloadData?.();
      setAlert(successTitle, successMessage(r), 'success');
      return r;
    })
    .catch((e) => {
      setAlert(errorTitle, e, 'danger');
      throw e;
    });
}
